import React from 'react';
import { ArrowLeft, Calendar, Clock } from 'lucide-react';
import { posts } from '../content/writing';
interface WritingPostProps {
  slug: string;
  onBack: () => void;
}
export function WritingPost({
  slug,
  onBack
}: WritingPostProps) {
  const post = posts.find(p => p.slug === slug);
  if (!post) {
    return <main className="bg-background text-foreground min-h-screen" data-id="element-228">
        <div className="container mx-auto px-6 md:px-12 py-24" data-id="element-229">
          <button onClick={onBack} className="flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors mb-8" data-id="element-230">
            <ArrowLeft size={20} data-id="element-231" />
            Back
          </button>
          <h1 className="text-3xl font-bold" data-id="element-232">Post not found</h1>
        </div>
      </main>;
  }
  return <main className="bg-background text-foreground min-h-screen" data-id="element-233">
      <div className="container mx-auto px-6 md:px-12 py-24 max-w-4xl" data-id="element-234">
        <button onClick={onBack} className="flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors mb-12 group" data-id="element-235">
          <ArrowLeft size={20} className="group-hover:-translate-x-1 transition-transform" data-id="element-236" />
          Back to all writing
        </button>

        <article className="space-y-8" data-id="element-237">
          {/* Header */}
          <div className="space-y-6" data-id="element-238">
            <div className="flex flex-wrap items-center gap-4 text-sm font-mono text-muted-foreground" data-id="element-239">
              <span className="flex items-center gap-1.5" data-id="element-240">
                <Calendar size={14} data-id="element-241" />
                {post.date}
              </span>
              <span className="flex items-center gap-1.5" data-id="element-242">
                <Clock size={14} data-id="element-243" />
                {post.readTime}
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl font-bold tracking-tight leading-tight" data-id="element-244">
              {post.title}
            </h1>

            <div className="flex flex-wrap gap-2" data-id="element-245">
              {post.tags.map(tag => <span key={tag} className="text-xs px-3 py-1.5 rounded-lg bg-secondary/50 dark:bg-white/5 text-muted-foreground border border-border/50 dark:border-white/10" data-id="element-246">
                  #{tag}
                </span>)}
            </div>
          </div>

          {/* Divider */}
          <div className="h-px bg-gradient-to-r from-transparent via-border to-transparent" data-id="element-247" />

          {/* Content */}
          <div className="prose prose-lg dark:prose-invert max-w-none" data-id="element-248">
            <p className="text-lg leading-relaxed text-muted-foreground" data-id="element-249">
              {post.excerpt}
            </p>

            <div className="mt-8 p-6 rounded-xl bg-card/50 dark:bg-white/5 border border-border/50 dark:border-white/10" data-id="element-250">
              <p className="text-sm text-muted-foreground italic" data-id="element-251">
                Full article content would be loaded here. This is a placeholder
                for the complete post content.
              </p>
            </div>
          </div>

          {/* Background gradient */}
          <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 to-purple-500/5 -z-10 rounded-3xl blur-3xl" data-id="element-252" />
        </article>
      </div>
    </main>;
}